import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { Form, Input, Button } from 'antd'
import * as req from '../../common/requests'

import css from '../../common/Form.css'

export default class DolphinSync extends Component {
  static propTypes = {
    practiceId: PropTypes.string.isRequired,
  }

  constructor(props) {
    super(props)

    this.state = {
      endpointId: null,
      error: false,
      loading: true,
      remoteDb: null,
    }

    this.saveEndpointId = this.saveEndpointId.bind(this)
  }

  async componentWillMount() {
    const { practiceId } = this.props
    try {
      const dbs = await req.getRemoteDatabases(practiceId)
      if (dbs.length) {
        const db = dbs[0]
        this.setState({
          endpointId: db.address,
          remoteDb: db,
          loading: false,
        })
      } else {
        this.setState({ loading: false })
      }
    } catch (err) {
      this.setState({ loading: false, error: true })
    }
  }

  async saveEndpointId() {
    const { practiceId } = this.props
    const { endpointId, remoteDb } = this.state
    const body = {
      practice_id: practiceId,
      address: endpointId,
    }
    try {
      if (remoteDb) {
        await req.updateRemoteDatabase(practiceId, remoteDb.id, body)
        await req.scheduleSync(remoteDb.id)
      } else {
        const newRemoteDb = await req.createRemoteDatabase(practiceId, body)
        await req.scheduleSync(newRemoteDb.id)
      }
    } catch (err) {
      this.setState({ error: true })
    }
  }

  changeEnterpiseId = (e) => {
    this.setState({ endpointId: e.target.value })
  }

  render() {
    const { endpointId, error, loading, remoteDb } = this.state
    const saveSuccess = remoteDb && remoteDb.address === endpointId
    const buttonText = saveSuccess ? 'Saved' : 'Save and Sync'

    return (
      <div>
        {error ? (
          <div> There was an error accessing the backend </div>
        ) : (
          <Form onSubmit={this.handleConnect}>
            <h3>Dolphin Sync</h3>
            <Form.Item label="Endpoint ID from Dolphin">
              <Input
                placeholder=""
                value={endpointId}
                name="endpointId"
                className={css.input}
                onChange={this.changeEnterpiseId}
              />
            </Form.Item>
            <Button
              htmlType="submit"
              loading={loading}
              disabled={!endpointId}
              type={saveSuccess ? 'primary' : null}
              onClick={this.saveEndpointId}
            >
              {buttonText}
            </Button>
          </Form>
        )}
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/AddPractice/Info/DolphinSync.js